import(/* webpackMode: "eager" */ "/vercel/path0/src/app/events/page.tsx");
